import { render, staticRenderFns } from "./LlQuizQuestionShow.vue?vue&type=template&id=5a816c9f"
import script from "./LlQuizQuestionShow.vue?vue&type=script&lang=js"
export * from "./LlQuizQuestionShow.vue?vue&type=script&lang=js"
import style0 from "./LlQuizQuestionShow.vue?vue&type=style&index=0&id=5a816c9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports